export default class Utils {

    static getScreenSize() {
        let element = document.documentElement;
        let body = document.getElementsByTagName('body')[0];
        let w = window.innerWidth || element.clientWidth || body.clientWidth;
        let h = window.innerHeight || element.clientHeight || body.clientHeight;

        return {
            w: w,
            h: h,
        }
    }

    /**
     * Real window width/height
     **/
    static xy() {
        let w = window,
            d = document,
            e = d.documentElement,
            g = d.getElementsByTagName('body')[0],
            x = w.innerWidth || e.clientWidth || g.clientWidth,
            y = w.innerHeight || e.clientHeight || g.clientHeight;
        return {x: x, y: y};
    }

}
